import React, { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import deepmerge from "deepmerge";
import { StepComp as Step } from "qjumpers.common.ui";
import {
  Loading,
  IntlFieldTemplateComp as IntlFieldTemplate,
  customWidgetsComp as customWidgets,
} from "qjumpers.common.ui";
import { customFields } from "../../../FormComponents/Fields";
import schemaJson from "./uiSchema/confidentialSchema.json";
import emptyQuestionnaireSchemaJson from "./uiSchema/EmptyQuestionnaire.json";
import {
  checkConfidentialQuestionnaireAnswers,
  loadBasicApplicationConfidentialQuestionnaire,
  saveQuickApplyConfidentialQuestionnaireAnswers,
} from "../../../requests/basicapplications";
import { toastMessageState } from "../../../recoil/toast/atom";
import { Button } from "react-bootstrap";
import { useSetRecoilState } from "recoil";
import { cloneDeep } from "lodash";
import { highlightRequiredQuestions } from "../ApplicationForm/applicationHelpers";

const ConfidentialQuestionnaire = () => {
  const popToast = useSetRecoilState(toastMessageState);
  const ref = useRef({});
  const [schema] = useState(schemaJson);
  const [confidentialQuestionnaireUiSchema, setConfidentialQuestionnaireUiSchema] = useState();
  const [submitting, setSubmitting] = useState(false);
  const [confidentialQuestionnaireId, setConfidentialQuestionnaireId] = useState();
  const location = useLocation();
  const urlQueries = new URLSearchParams(location.search);

  const getQuestionnaireFrom = (questionnaireResponse, key) => {
    var questionnaireClone = cloneDeep(emptyQuestionnaireSchemaJson);
    questionnaireClone.content[0].content[0].key = key;
    questionnaireClone.content[0].content[0].schema["ui:options"].survey = JSON.parse(
      questionnaireResponse.model
    ).model;
    return {
      newSurveyUiSchema: questionnaireClone,
      questionnaireId: questionnaireResponse.id,
    };
  };

  const getJobIdParam = () => {
    const url = window.location.href.split("/");
    const jobId = url[url.length - 1].split("?")[0];

    return jobId;
  };

  useEffect(() => {
    const jobId = getJobIdParam();
    const cid = urlQueries.get("cid");
    if (jobId) {
      loadBasicApplicationConfidentialQuestionnaire(jobId).then((result) => {
        const confidentialQuestionnaire = getQuestionnaireFrom(result.data, "confidentialQuestionnaireAnswer.model");
        setConfidentialQuestionnaireId(result.data.id);
        setConfidentialQuestionnaireUiSchema(confidentialQuestionnaire.newSurveyUiSchema);
      });

      checkConfidentialQuestionnaireAnswers(jobId, cid).then((result) => {
        if (result.data === true) {
          alert("You have already submitted Confidential Information for this job");
          window.location.href = window.location.origin;
        }
      });
    }
  }, []);

  const onFormDataChange = ({ formData: formDataInput }) => {
    let updatedFormData = deepmerge.all([ref.current, formDataInput]);
    //In this function set state is not working hence find out work around for it.
    ref.current = updatedFormData;
  };

  const onModalClose = () => {
    window.location.href = window.location.origin;
  };

  const updateConfidentialQuestionnaireAnswers = () => {
    let formDataFromRef = cloneDeep(ref.current);
    if (formDataFromRef.confidentialQuestionnaireAnswer) {
      formDataFromRef.confidentialQuestionnaireAnswer.questionnaireId = confidentialQuestionnaireId;
      let data = formDataFromRef.confidentialQuestionnaireAnswer;
      let answers = data?.model ? JSON.parse(data.model) : undefined;

      if (answers && !answers.errors) {
        const jobId = getJobIdParam();
        const candidateId = urlQueries.get("cid");
        setSubmitting(true);
        saveQuickApplyConfidentialQuestionnaireAnswers(
          jobId,
          candidateId,
          formDataFromRef.confidentialQuestionnaireAnswer
        )
          .then((result) => {
            setSubmitting(false);
            alert("Answers submitted successfully.");
            if (result.data == null) {
              popToast([
                {
                  type: "success",
                  title: "Success",
                },
              ]);
            } else {
              popToast([
                {
                  type: "error",
                  title: result.Message,
                },
              ]);
            }
            window.location.href = window.location.origin;
          })
          .catch((e) => {
            console.error(e);
          });
      } else {
        highlightRequiredQuestions();
        scrollToFirstError();
      }
    } else {
      highlightRequiredQuestions();
      scrollToFirstError();
    }
  };

  const scrollToFirstError = () => {
    setTimeout(() => {
      const divElements = document.querySelectorAll("div[id*=sq_]");
      const erroredDivs = Array.from(divElements).filter((div) => {
        return div.classList.contains("has-error");
      });

      // Check if there are errors
      if (erroredDivs.length > 0) {
        // Scroll to the first matching div
        erroredDivs[0].scrollIntoView({ behavior: "smooth" });
      }
    }, 100);
  };

  if (!confidentialQuestionnaireUiSchema) {
    return null;
  }

  return (
    <div>
      {submitting ? (
        <div className="formLoader">
          <Loading className="loading-component" />
        </div>
      ) : null}

      <div className="container border-0">
        <br />
        <br />
        <div className="col-12">
          <div className="container border-0">
            <div className="row">
              <Step
                schema={schema}
                liveValidate={true}
                uiSchema={confidentialQuestionnaireUiSchema}
                noValidate={false}
                fields={customFields}
                widgets={customWidgets}
                FieldTemplate={IntlFieldTemplate}
                onUpdate={onFormDataChange}
              />
            </div>
            <Button variant="success" onClick={updateConfidentialQuestionnaireAnswers}>
              Submit
            </Button>
            <Button variant="danger" onClick={onModalClose}>
              Cancel
            </Button>
            <br />
            <br />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConfidentialQuestionnaire;
